// Public pages are cached and never read the session cookie, so the header
// can't know who is signed in. The server sets a readable `coy_signed_in=1`
// cookie next to the httponly session cookie and deletes it on sign out; the
// header reads it and swaps the links marked data-account-link. It grants
// nothing: /app still checks the real session and sends a stale hint to /login.
export const HINT_COOKIE = 'coy_signed_in'

export function isSignedIn(cookie: string = document.cookie): boolean {
  return cookie.split(';').some((part) => part.trim() === `${HINT_COOKIE}=1`)
}

// <a data-account-link data-signed-in-href="/en/app" data-signed-in-label="My letters">Sign in</a>
export function applySessionHint(root: ParentNode = document, cookie: string = document.cookie): void {
  if (!isSignedIn(cookie)) return
  root.querySelectorAll<HTMLAnchorElement>('[data-account-link]').forEach((link) => {
    if (link.dataset.signedInHref) link.href = link.dataset.signedInHref
    if (link.dataset.signedInLabel) link.textContent = link.dataset.signedInLabel
  })
}
